const logoSlider = ($block = document) => {
  const carousels = $block.querySelectorAll('.logo-slider__carousel');
  if (carousels) {
    carousels.forEach((carousel) => {
      const parent = carousel.parentElement;
      for (let i = 0; i < 2; i++) {
        const clone = carousel.cloneNode(true);
        parent.appendChild(clone);
      }
      parent.querySelectorAll('.logo-slider__carousel').forEach((elem) => {
        elem.classList.add('logo-slider__carousel--animation');
      });
    });
  }
};

window.document.addEventListener('DOMContentLoaded', () => {
  if (window.acf) {
    window.acf.addAction('render_block_preview/type=azds/logo-slider', ($block) => {
      logoSlider($block[0]);
    });
  }
});

export default logoSlider;
